
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import Banner from '@/components/banner/Banner.vue';
import VehicleCart from './VehicleCart.vue';
import PartCart from './PartCart.vue';
import { getAllCustomerCompany } from '@/api/apis';

export default defineComponent({
  name: 'ShoppingCart',
  components: {
    Banner,
    VehicleCart,
    PartCart
  },
  data() {
    return {
      consigneeDropdownList: [],
      tab: 1
    };
  },
  created() {
    this.loadConsignee();
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    async loadConsignee() {
      const res = await getAllCustomerCompany({
        customerId: this.userInfo.id
      });

      if (res && res.success) {
        this.consigneeDropdownList = res.result || [];
      }
    },
    handleTabChange(tab) {
      this.tab = tab;

      this.$router.push(`/shoppingcart?tab=${this.tab}`);
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        if (val.name === 'ShoppingCart') {
          const tab = +val.query.tab;
          if (tab && !isNaN(tab) && [1, 2].includes(tab)) {
            this.tab = tab;
          } else {
            this.$router.push(`/shoppingcart?tab=${this.tab}`);
          }
        }
      }
    }
  }
});
